import { render } from "./FormConfirmSubmitDialog.vue?vue&type=template&id=233d1ff2"
import script from "./FormConfirmSubmitDialog.vue?vue&type=script&lang=js"
export * from "./FormConfirmSubmitDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__